import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BlogHeader() {
  return (
    <header className="backdrop-blur-md bg-white/80 border-b border-neutral-200/80 sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="blog-brand" className="flex items-center gap-2 font-display font-extrabold text-lg tracking-tight">
          <img src="/lumora-logo.png" alt="Lumora" className="w-7 h-7" />
          LUMORA<span className="text-[#E05638]">.</span>
        </Link>
        <div className="flex items-center gap-5">
          <Link
            to="/"
            data-testid="blog-back-home"
            className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-[#111111] transition-colors"
          >
            <ArrowLeft size={15} /> Home
          </Link>
          <Link
            to="/dashboard"
            data-testid="blog-client-area-link"
            className="rounded-full bg-[#111111] text-white text-sm font-medium px-5 py-2 hover:bg-[#E05638] transition-colors"
          >
            Area Clienti
          </Link>
        </div>
      </div>
    </header>
  );
}
